import jwtDecode from 'jwt-decode';

export const getTokenExp = () => {
    return jwtDecode(getToken()).exp;
};

export const getToken = () => sessionStorage.getItem('ipsadToken');

export const isAdminUser = () => {
    return jwtDecode(sessionStorage.getItem('ipsadToken')).role === 'COMPANY_ADMIN' ||
        jwtDecode(sessionStorage.getItem('ipsadToken')).role === 'SUPER_ADMIN';
}

export const selectOptionsIntoArray = options => {
    const values = Object.keys(options);
    const labels = Object.values(options);

    const selectOptionsArray = values.map((value, index) => (
        {value: value, label: labels[index]}
    ));

    return selectOptionsArray;
};
